export default __webpack_public_path__ + "8f7327e6f0c13eaa117e269173da289c.svg";